import type { Event } from "@shared/schema";

/**
 * New event links use the durable human-readable slug. The UUID fallback is
 * retained while older rows are being lazily backfilled by the API.
 */
export function eventPath(event: Pick<Event, "id" | "slug">): string {
  return `/events/${encodeURIComponent(event.slug || event.id)}`;
}